import { Role } from '../models/role';
import { DrEntity } from './dr-entity';
import { DrObject, DrObjectType, SupportedRegExType } from './dr-object';
import { isArray } from './utils';

export class GroupViewModel extends DrObject {

    model: Partial<Group>;

    constructor(value?: Partial<Group>) {
        super(DrObjectType.GROUP, SupportedRegExType.USER_GROUP);
        if (value) {
            this.model = value;
        }
    }
}


export class Group extends DrEntity {
    description: string;
    expression: string;
    importedFromSystemGroup: boolean;
    name: string;
    orgName: string;
    roleHandles: Array<string>;
    roles: Array<Role>;

    groupRole: string;
    type: string;
    iconClass: string;

    constructor(value?: Partial<Group>) {
        super(value);
        if (value) {
            if (isArray(value.roles) && value.roles.length > 0) {
                value.roles = value.roles.map(role => new Role(role));
                value.groupRole = value.roles[0].name;
            }
            value.type = value.importedFromSystemGroup || value.orgName === 'super_system_customer'? 'System Group' : 'Group';
            value.iconClass = `fa-users ${value.type === 'System Group' ? ' color-purple-03' : ' color-yellow-07'}`;
            Object.assign(this, value);
        }
    }
}
